import { OnInit , Component} from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';

@Component({
    selector: 'mcv-header',
    templateUrl: './mcv-header.component.html'
})
export class MCVHeaderComponent implements OnInit {
    clientName: string;
    userId: string;
    subscriberId: string;
    loginId: string;

    constructor(private translationService: PershingTranslationService, private paramService: NxiRestService) {
      this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');
    }
    ngOnInit( ) {
      this.getAdvisorResponse();
  }

  getAdvisorResponse(): any {
    this.paramService.getAdvisorResponse('/portfolio/getAdvisorVO').subscribe(
    resp => {
      console.log('response', resp);
      this.clientName  = resp.clientName;
      this.userId = resp.userId;
      this. subscriberId = resp.subscriberId;
      this.loginId = resp.loginId;
    },
   error => {
      console.log('error', error);
      return error;
    }
  );
  }

  onLogoutClick(): void {
      document.dispatchEvent(new CustomEvent('portal.DASFLogoutEvent'));
      window.close();
  }
}

